import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
          <li>
            <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">
              {t('breadcrumbHome')}
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              <i className="ri-arrow-right-s-line text-xs"></i>
              {item.path ? (
                <Link to={item.path} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}